import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function formatDate(dateString) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

function GestionProjet() {
  const [projet, setProjet] = useState({
    Nom_Projet: '',
    Description_Projet: '',
    Date_Debut_Projet: '',
    Date_Fin_Projet: '',
    Objectif_Projet: '',
    Matos_Projet: '',
    Partenaire_Projet: '',
    Url_Projet: '',
    Id_Responsable_Projet: '',
  });

  const [projets, setProjets] = useState([]);
  const [eleves, setEleves] = useState([]);
  const [clubId, setClubId] = useState('');
  const [clubName, setClubName] = useState('');
  const navigate = useNavigate();
  const [formVisible, setFormVisible] = useState(false); 
  const [projectsVisible, setProjectsVisible] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/connexion');
    } else {
      try {
        const clubData = JSON.parse(atob(token.split('.')[1]));
        setClubId(clubData.id);
        fetchClubInfo(clubData.id);
        fetchProjets(clubData.id);
        fetchEleves(clubData.id);
      } catch (error) {
        console.error('Erreur lors du décodage du token', error);
        navigate('/connexion');
      }
    }
  }, [navigate]);

  const fetchClubInfo = async (clubId) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`https://www.clublfit.org/api/clubs/${clubId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setClubName(response.data.Nom_Club);
    } catch (error) {
      console.error('Erreur lors de la récupération des informations du club', error);
      if (error.response && error.response.status === 401) {
        alert('Session expirée. Veuillez vous reconnecter.');
        navigate('/connexion');
      }
    }
  };

  const fetchProjets = async (clubId) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`http://54.36.103.84:5000/api/clubs/projets/${clubId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const projectsWithImages = response.data.map((project) => {
        if (project.Photo_Projet && project.Photo_Projet.data) {
          const blob = new Blob([new Uint8Array(project.Photo_Projet.data)], { type: 'image/png' });
          const imageUrl = URL.createObjectURL(blob);
          return { ...project, imageUrl };
        } else {
          console.warn(`Image blob missing for project ID: ${project.Id_Projet}`);
          return { ...project, imageUrl: "https://via.placeholder.com/850x450" }; // Image par défaut si absente
        }
      });
      
      setProjets(projectsWithImages);
    } catch (error) {
      console.error('Erreur lors de la récupération des projets', error);
    }
  };

  const fetchEleves = async (clubId) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`http://54.36.103.84:5000/api/clubs/Membres/${clubId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setEleves(response.data);
    } catch (error) {
      console.error('Erreur lors de la récupération des élèves', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProjet({ ...projet, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    const projetAvecDates = {
      ...projet,
      Id_Club_Projet: clubId,
      Date_Debut_Projet: projet.Date_Debut_Projet || null,
      Date_Fin_Projet: projet.Date_Fin_Projet || null,
    };

    try {
      await axios.post(
        'http://54.36.103.84:5000/api/clubs/projets',
        projetAvecDates,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert('Projet créé avec succès');
      fetchProjets(clubId);
    } catch (error) {
      console.error('Erreur lors de la création du projet : ', error);
      if (error.response) {
        console.log('Détails de l\'erreur : ', error.response.data);
      } else {
        console.error('Erreur inattendue : ', error.message);
      }
      alert('Erreur lors de la création du projet');
    }
  };

  const toggleFAQ = (index) => {
    if (index === 0) setFormVisible(!formVisible);
    if (index === 1) setProjectsVisible(!projectsVisible);
  };

  return (
    <div className="container">
      <div className="faq-item">
        {/* Formulaire de création de projet */}
        <div className={`faq-question ${formVisible ? 'active' : ''}`} onClick={() => toggleFAQ(0)}>
          <h2 className="text-center mb-4 no-dark-mode">Gestion des Projets pour le club {clubName || 'Chargement...'}</h2>
        </div>
        {formVisible && (
          <div className="faq-answer">
            <form onSubmit={handleSubmit} className="mb-5">
              <h4>Créer un Projet</h4>
              <div className="mb-3">
                <input
                  type="text"
                  name="Nom_Projet"
                  placeholder="Nom du projet"
                  value={projet.Nom_Projet}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <textarea
                  name="Description_Projet"
                  placeholder="Description du projet"
                  value={projet.Description_Projet}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <input
                  type="date"
                  name="Date_Debut_Projet"
                  value={projet.Date_Debut_Projet}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <input
                  type="date"
                  name="Date_Fin_Projet"
                  value={projet.Date_Fin_Projet}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  name="Objectif_Projet"
                  placeholder="Objectif du projet"
                  value={projet.Objectif_Projet}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  name="Matos_Projet"
                  placeholder="Matériel requis"
                  value={projet.Matos_Projet}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  name="Partenaire_Projet"
                  placeholder="Partenaires"
                  value={projet.Partenaires_Projet}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <input
                  type="url"
                  name="Url_Projet"
                  placeholder="Lien URL (facultatif)"
                  value={projet.Url_Projet}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              {/* Sélection du responsable du projet */}
              <div className="mb-3">
                <label>Responsable du Projet</label>
                <select
                  name="Id_Responsable_Projet"
                  value={projet.Id_Responsable_Projet}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">Sélectionner un élève</option>
                  {eleves.map((eleve) => (
                    <option key={eleve.Id_Eleves} value={eleve.Id_Eleves}>
                      {eleve.Prenom_Eleves} {eleve.Nom_Eleves}
                    </option>
                  ))}
                </select>
              </div>

              <button type="submit" className="btn btn-primary">Enregistrer le Projet</button>
            </form>
          </div>
        )}

        {/* Projets */}
        <div className={`faq-question ${projectsVisible ? 'active' : ''}`} onClick={() => toggleFAQ(1)}>
          <h2 className="text-center mb-4 no-dark-mode">Projets</h2>
        </div>
        {projectsVisible && (
          <div className="faq-answer">
            <div className="d-flex flex-wrap justify-content-center">
              {projets.length > 0 ? (
                projets.map((projet) => (
                  <div key={projet.Id_Projet} className="project-card m-3">
                    <div className="team-item">
                      <ul className="team-social">
                        <li><a href="#"><i className="bi bi-camera"></i></a></li>
                        <li><a href="#"><i className="bi bi-info-circle"></i></a></li>
                        <li><a href="#"><i className="bi bi-check-circle"></i></a></li>
                        <li><a href="#"><i className="bi bi-hand-thumbs-up"></i></a></li>
                        <li><a href="#"><i className="bi bi-envelope"></i></a></li>
                      </ul>
                      <img src={projet.imageUrl || "https://via.placeholder.com/850x450"} alt={projet.Nom_Projet} />
                      <div className="team-info">
                        <h5><a href="#">{projet.Nom_Projet}</a></h5>
                        <h6>Responsable: {projet.Prenom_Eleves} {projet.Nom_Eleves} {projet.Classe_Eleves}</h6>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>Aucun projet pour le moment.</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default GestionProjet;
